import { Route, Switch } from 'react-router';
import { ConfigurationChangelogDetailPage } from './ConfigurationChangelogDetailPage';
import { ConfigurationChangelogPage } from './ConfigurationChangelogPage';
import {
  configurationChangelogDetailRoute,
  configurationChangelogPath,
} from './routes';

export const ConfigurationChangelogRoutes = () => (
  <Switch>
    <Route
      path={configurationChangelogPath()}
      exact
      component={ConfigurationChangelogPage}
    />
    <Route
      path={configurationChangelogDetailRoute}
      exact
      component={ConfigurationChangelogDetailPage}
    />
  </Switch>
);
